"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const RadioLabelDescription_1 = __importDefault(require("./RadioLabelDescription"));
exports.default = RadioLabelDescription_1.default;
